import { createContext } from 'react';

import { useGuardedContext } from '@/hooks/useGuardedContext';

export interface ClientListPageContext {
  filterValue: Record<string, string[]>;
  setFilterValue: (value: Record<string, string[]>) => void;
}

export const ClientListPageContext = createContext<ClientListPageContext>({
  filterValue: {},
  setFilterValue: () => null,
});

export const useClientListPageContext = () => {
  return useGuardedContext(ClientListPageContext, 'ClientListPageProvider');
};
